<template>
  <div class="ttn-filters">
    <el-row type="flex" align="middle" justify="space-between">
      <h3 class="mt-0">Поиск рейса по ТТН</h3>
      <el-button type="text" class="td-u" @click="resetAll()">
        Сбросить
      </el-button>
    </el-row>
    <el-form
      v-if="!hidden"
      @submit.native.prevent
      @keyup.enter.native="handleSearch"
    >
      <el-row type="flex" align="middle" class="mb-5">
        <p class="w-150">Дата ТТН:</p>
        <el-date-picker
          v-model="date_from"
          :picker-options="pickerOpt"
          :clearable="false"
          type="date"
          size="small"
          format="dd.MM.yyyy"
          value-format="timestamp"
          @change="handleChange"
        />
      </el-row>
      <el-row type="flex" align="middle" class="mb-5">
        <p class="w-150">Выберите погрузку:</p>
        <bids-autocomplete
          :text="text"
          :disabled="!date_from"
          :search="fetchBids"
          @selected="handleSelect"
          @set="handleSet"
        />
      </el-row>
      <el-row type="flex" align="middle" class="mb-5">
        <p class="w-150">Номер авто:</p>
        <el-input
          ref="plate_truck"
          v-model="plate_truck"
          size="small"
          placeholder="Поиск авто"
          :disabled="!date_from"
        />
      </el-row>
      <el-row class="ta-r mt-10">
        <el-button
          :disabled="disabled"
          :loading="loadingResponses"
          type="primary"
          size="small"
          @click="handleSearch"
        >
          Поиск
        </el-button>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { pickerOpt } from '@/datas/consts'
import BidsAutocomplete from './BidsAutocomplete'

export default {
  name: 'TtnFilters',
  components: { BidsAutocomplete },
  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
    hidden: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pickerOpt,
      text: '',
      date_from: '',
      bid_id: '',
      plate_truck: '',
    }
  },
  computed: {
    ...mapGetters('hardware', ['getLoading']),
    loadingResponses() {
      return this.getLoading('Responses')
    },
    disabled() {
      return (
        !this.date_from ||
        (!this.bid_id && !this.plate_truck) ||
        this.loadingResponses
      )
    },
  },
  methods: {
    ...mapActions('hardware', ['fetchTtnBids', 'fetchTtnResponses']),
    fetchBids(load_point_text = '') {
      const date_from = this.date_from / 1000

      return this.fetchTtnBids({ date_from, load_point_text })
    },
    handleChange() {
      this.resetAll(false)
      this.fetchBids()
    },
    handleSearch() {
      const { bid_id, plate_truck } = this

      if (!this.disabled) {
        const date_from = this.date_from / 1000

        this.fetchTtnResponses({ date_from, bid_id, plate_truck })
        this.$emit('searched')
      }
    },
    handleSelect(id = '') {
      this.bid_id = id
      this.$refs?.plate_truck.focus()
    },
    handleSet(text = '') {
      this.text = text
    },
    resetAll(all = true) {
      if (this.hidden) {
        this.$emit('back')
      } else {
        if (all) {
          this.date_from = ''
        }
        this.text = ''
        this.bid_id = ''
        this.plate_truck = ''
        this.$emit('reset')
      }
    },
  },
}
</script>

<style lang="sass">
.ttn-filters
  .w-150
    width: 150px
    flex: none
  .mb-5
    margin-bottom: 5px
  .mt-10
    margin-top: 10px
  .mt-0
    margin-top: 0
</style>
